import { useState, useRef, useEffect } from "react";
import { MdOutlineDelete } from "react-icons/md";
import UploadImage from "../../../components/molecules/UploadImage";
import TextInput from "../../../components/molecules/inputs/TextInput";
import { IoMdAdd } from "react-icons/io";
import api from "../../../Api";
import axios from "axios";
import Skeleton from "react-loading-skeleton";

interface PartnerItem {
  _id?: string;
  Img: string;
  Url: string;
  Name: string;
}

export default function Prtners() {
  const [isPopUpOpen, SetIsPopUpOpen] = useState(false);
  const [uploadedImage, setUploadedImage] = useState<File | string>("");
  const [inputValue, setInputValue] = useState("");
  const [companyName, SetCompanyName] = useState("");
  const popUpRef = useRef<HTMLDivElement>(null);
  const [partners, SetPartners] = useState<PartnerItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [popUpLoading, setPopupLoading] = useState(false);

  const handleImageUpload = (file: File) => {
    setUploadedImage(file); // Accept the file object
  };

  const handleInputChange = (value: string) => {
    setInputValue(value);
  };

  const handleCompanyName = (value: string) => {
    SetCompanyName(value);
  };

  // Handle clicks outside the popup
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popUpRef.current &&
        !popUpRef.current.contains(event.target as Node)
      ) {
        SetIsPopUpOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside); // Cleanup
    };
  }, []);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await axios.get(api.partners, {
          headers: {
            api_key: api.key,
            authentication: api.authantication,
          },
        });
        SetPartners(response.data.partners);
      } catch (error) {
        console.error("Error fetching our Support:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  const handleSubmit = async () => {
    if (!uploadedImage || typeof uploadedImage === "string") {
      alert("Please upload an image.");
      return;
    }

    const formData = new FormData();
    formData.append("file", uploadedImage);

    try {
      setPopupLoading(true);
      const uploadResponse = await axios.post(api.uploadFile, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (uploadResponse.data.success) {
        const uploadedImageUrl = uploadResponse.data.url;

        const partnerItem: PartnerItem = {
          Img: uploadedImageUrl,
          Name: companyName,
          Url: inputValue,
        };

        const response = await axios.post(api.partners, partnerItem, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.data.success) {
          SetPartners((prevPartners) => [...prevPartners, partnerItem]);
          SetIsPopUpOpen(false);
          setPopupLoading(false);
        } else {
          setPopupLoading(false);
          console.warn("Failed to add partner. Please try again.");
        }
      } else {
        console.error("Failed to upload image. Please try again.");
      }
    } catch (error) {
      console.error("Error adding support item:", error);
    }
  };

  // Delete our support handler
  const handleDeletePartner = async (partnerId: string) => {
    try {
      await axios.delete(`${api.partners}/${partnerId}`, {
        headers: {
          api_key: api.key,
          authentication: api.authantication,
        },
      });

      SetPartners((prevPartners) =>
        prevPartners.filter((partner) => partner._id !== partnerId)
      );
    } catch (error) {
      console.error("Error deleting testimonial:", error);
    }
  };

  return (
    <div>
      {/* Side PopUp */}
      <div
        ref={popUpRef}
        className={`bg-white fixed top-0 z-10 w-[400px] border-l ${
          isPopUpOpen ? "right-0" : "right-[-500px]"
        } h-full p-4 duration-300 space-y-4`}
      >
        <div className="space-y-2">
          <h1 className="font-primary text-title">Add Partners</h1>
          <p className="text-black/[.60]">
            Add partners of your company order to provide products to your
            custormers
          </p>
        </div>

        <UploadImage
          ButtonText="Upload partner's logo"
          bigImage={true}
          onUpload={handleImageUpload}
        />

        <TextInput
          Name="Company Name"
          Placeholder="Enter partners company name"
          Value={companyName}
          onChange={handleCompanyName}
        />

        <TextInput
          Name="Website"
          Placeholder="Enter partners website url"
          Value={inputValue}
          Capitalize={false}
          onChange={handleInputChange}
        />

        <div className="flex items-center justify-end space-x-4">
          <p
            onClick={() => SetIsPopUpOpen(false)}
            className="text-black/[.60] cursor-pointer"
          >
            cancel
          </p>
          <div
            onClick={handleSubmit}
            className="bg-primary text-white hover:bg-primary_dark duration-300 p-2 px-4 rounded hover:cursor-pointer"
          >
            <p>{popUpLoading ? "Submiting..." : "Submit"}</p>
          </div>
        </div>
      </div>

      {/* Our Support Map */}
      <div className="grid grid-cols-6 gap-4">
        {loading
          ? Array.from({ length: 6 }).map((_, index) => (
              <Skeleton key={index} height={150} />
            ))
          : partners.map((partner) => (
              <div
                key={partner.Name}
                className="flex items-center gap-4 bg-white p-2 py-3 border rounded group cursor-pointer relative"
              >
                <img
                  className="w-full object-cover"
                  onClick={() => window.open(partner.Url, "_blank")}
                  src={partner.Img}
                  alt="img"
                />

                <MdOutlineDelete
                  onClick={() => handleDeletePartner(partner._id!)}
                  className={`text-[20px] group-hover:text-red-500 text-red-500/[.0] duration-300 absolute top-4 right-4`}
                />
              </div>
            ))}
      </div>

      <div
        onClick={() => SetIsPopUpOpen(true)}
        className="bg-primary w-[46px] h-fit hover:w-[150px] p-3 text-[22px] text-white rounded-full fixed right-4 bottom-4 group duration-300 flex items-center gap-2 cursor-pointer"
      >
        <IoMdAdd />
        <p className="text-[16px] hidden h-[24px] pr-2 group-hover:flex duration-300">
          Add Partner
        </p>
      </div>
    </div>
  );
}
